import React, { useState } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";
import { Choice, INK } from "../Ink";

export const REWARD_KINDS = {
  thankYou: { label: "Thank", title: "Send a thank-you", field: "message", placeholder: "A few words for this fan" },
  customBadge: { label: "Badge", title: "Grant a badge", field: "badge", placeholder: "Badge name, e.g. Day-one crew" },
  freeRequest: { label: "Free request", title: "Give a free jukebox request", field: null },
  earlyRelease: { label: "Early access", title: "Give early access to your next release", field: null },
};

const KIND_OPTIONS = Object.entries(REWARD_KINDS).map(([value, spec]) => ({ value, label: spec.label }));

const fieldSx = {
  "& .MuiInputBase-root": { color: INK.text, fontSize: 14 },
  "& .MuiInput-underline:before": { borderBottomColor: INK.rule },
  "& .MuiInput-underline:hover:not(.Mui-disabled):before": { borderBottomColor: INK.muted },
  "& .MuiInput-underline:after": { borderBottomColor: INK.text },
};

// Minimal dark dialog: pick the reward kind (unless the caller fixes `kind`),
// fill its one field when it has one, cancel/send. Submits `{ kind, [field] }`.
export default function RewardDialog({ open, kind: fixedKind, fanName, busy, onClose, onSubmit }) {
  const [kind, setKind] = useState(REWARD_KINDS[fixedKind] ? fixedKind : "thankYou");
  const [text, setText] = useState("");
  const spec = REWARD_KINDS[kind];
  const needsText = Boolean(spec.field);
  const pick = (next) => {
    setKind(next);
    setText("");
  };
  const submit = () => onSubmit({ kind, ...(needsText ? { [spec.field]: text.trim() } : {}) });

  return (
    <Dialog open={open} onClose={busy ? undefined : onClose} fullWidth maxWidth="xs" PaperProps={{ sx: { bgcolor: "#0E0E12", border: `1px solid ${INK.rule}`, borderRadius: "4px", backgroundImage: "none" } }}>
      <DialogTitle sx={{ color: INK.text, fontSize: 16, fontWeight: 700, pb: 0.5 }}>Reward {fanName || "this fan"}</DialogTitle>
      <DialogContent>
        {fixedKind ? null : <Choice ariaLabel="Reward kind" options={KIND_OPTIONS} value={kind} onChange={pick} sx={{ mb: 1.5 }} />}
        <Typography sx={{ fontSize: 13, color: INK.muted, mb: needsText ? 1.5 : 0 }}>{spec.title}.</Typography>
        {needsText ? (
          <TextField
            key={kind} autoFocus fullWidth variant="standard" multiline={spec.field === "message"} minRows={spec.field === "message" ? 2 : 1}
            placeholder={spec.placeholder} value={text} onChange={(e) => setText(e.target.value)} inputProps={{ maxLength: 240 }} sx={fieldSx}
          />
        ) : null}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={busy} sx={{ color: INK.muted, textTransform: "none" }}>Cancel</Button>
        <Box sx={{ flex: 1 }} />
        <Button onClick={submit} disabled={busy || (needsText && !text.trim())} sx={{ color: INK.accent, textTransform: "none", fontWeight: 700 }}>
          {busy ? "Sending…" : "Send"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
